<script lang="ts" setup>
import { useConfigStore } from '~/store/useConfigStore'

const store = useConfigStore()
const { footerMenu } = storeToRefs(store)
</script>

<template>
  <Menu
    v-if="footerMenu"
    :menu="footerMenu"
    class="footer-menu"
  />
</template>

<style lang="scss" scoped>
 .footer-menu {
    @apply flex items-center justify-center gap-[20px] flex-wrap;
    @apply md:flex-nowrap md:justify-start;
    @apply xl:gap-x-[60px] xl:ml-auto;

    :deep(.static-url-menu-item) {
      @apply normal-case text-[14px] text-white/60 transition-colors duration-300;
      @apply hover:text-white;
    }

    :deep(.menu-item__top-level) {
      @apply w-auto;
    }
  }
</style>
